module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"OWNER":"Propriétaire","CONSIGNER":"Consigner","VISIT":"Lieu de visite","REGISTRATION":"Inscription"}}')
  delete Component.options._Ctor
}
